/**
 * Created by mykurisu on 2017/12/7.
 */
import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import Close from '../../images/activity/couponspa/close.png'


class MainActiveCoupon extends React.Component {
    constructor() {
        super();
        this.bagid = '8'
        this.state = {
            beginShowTime: false,
            isDialogShow: false,
            dialogUrl: '',
            dialogImg: '',
            dialogId: '',
            dialogIndex: '',
            isA: true,
        }
    }

    componentDidMount() {
        this.fetchCoupon()
    }

    fetchCoupon () {
        axios.get(`/popwindow/api/config/request/index/popwindow/`)
            .then(res => {
                const data = res.data.data
                if (res.data.code === 0) {
                    this.setState({
                        dialogId: data.config.id,
                        dialogImg: data.config.img_url,
                        dialogUrl: data.config.link,
                        dialogIndex: data.config.index,
                    })
                    this.popDialog(data.config)
                }
            })
    }

    toggleDialog (action) {
        let param = new FormData()
        param.append('config_id', this.state.dialogId)
        if (action === 'click') {
            return axios.post(`/popwindow/api/record/${action}/index/popwindow/`, param)
        }
        axios.post(`/popwindow/api/record/${action}/index/popwindow/`, param)
    }

    popDialog (config) {
        let isA
        if (config.open_test) {
            isA = config.test_case === 'a'
        } else {
            isA = true
        }
        this.setState({ isA, isDialogShow: true })
        this.mta(`main-dialog-show-${config.id}-${isA ? 'a' : 'b'}`)
        this.header && this.header.addEventListener('webkitAnimationEnd', () => {
            this.setState({beginShowTime: true})
        })
    } 

    mta (payload) {
        this.props.dispatch({ type: 'MTA_CLICK', payload });
    }

    onClickDialog (e) {
        const isA = this.state.isA
        e.stopPropagation()
        this.setState({ isDialogShow: false })
        this.mta(`main-dialog-${this.state.dialogId}-click-${isA ? 'a' : 'b'}`)
        this.toggleDialog('click').then(() => {
            console.log(this.getHasInviterIdUrl())
            location.assign(this.getHasInviterIdUrl())
        })
    }

    onCloseDialog(e) {
        e.stopPropagation()
        this.toggleDialog('cancel')
        this.setState({ isDialogShow: false })
        this.mta(`main-dialog-${this.state.dialogId}-close-${this.state.isA ? 'a' : 'b'}`)
    }

    getHasInviterIdUrl () {
        const { dialogIndex, dialogUrl, isA } = this.state
        const querySymbol = dialogUrl.includes('?') ? '&' : '?'
        let backFollowedInviterId, backNoFollowedInviterId, othersInviterId
        if (dialogIndex === 0) {
            backFollowedInviterId = isA ? '44006949' : '53845374'
            backNoFollowedInviterId = isA ? '44814268' : '53845447'
            othersInviterId = isA ? '44814368' : '54460640'
        } else if (dialogIndex === 1) {
            backFollowedInviterId = isA ? '52439452' : '53845210'
            backNoFollowedInviterId = isA ? '52439551' : '53845263'
            othersInviterId = isA ? '52440369' : '53845298'
        } else {
            backFollowedInviterId = isA ? '54460715' : '55790658'
            backNoFollowedInviterId = isA ? '54460755' : '55790717'
            othersInviterId = isA ? '54460799' : '55790861'
        }
        const from = this.props.location.query.from
        if (from === 'outside_site') {
            if (this.props.account.subscribed) {
                return `${dialogUrl}${querySymbol}inviter_id=${backFollowedInviterId}`
            } else {
                return `${dialogUrl}${querySymbol}inviter_id=${backNoFollowedInviterId}`
            }
        } else {
            return `${dialogUrl}${querySymbol}inviter_id=${othersInviterId}`
        }
    }

    render() {
        if (this.state.isDialogShow){
            return (
                <div className="mainactive__coupon" onClick={(e) => this.onCloseDialog(e)}>
                    <div className="coupon__img" style={{marginTop: '-50px'}} ref={r => this.header = r} onClick={(e) => this.onClickDialog(e)}>
                        <img src={this.state.dialogImg} alt="" />
                        <div className="coupon__close" style={{opacity: this.state.beginShowTime ? '1' : '0'}}>
                            <img src={Close} alt="" onClick={(e) => this.onCloseDialog(e)}/>
                        </div>
                    </div>
                </div>
            )
        }
        return null
    }
}

export default connect((state) => ({
    account: state.account
}))(MainActiveCoupon)




// WEBPACK FOOTER //
// ./src/components/main/MainActiveCoupon.js